import { useEffect, useState, useCallback } from "react";
import { CommonPropertyProps } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import api from "lib/api";
import { useTranslation } from "react-i18next";
import { status } from "../../../../constants";
import axios from "axios";
import { AlertProps, SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps;
	optionsId?: SearchSelectOptionProps;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
};

export default ({
	isEmu,
	updateStore,
	field,
	required,
	value,
	desc,
	optionsId,
	validation,
	elementIndex,
	addAlert,
}: Props) => {
	const { t } = useTranslation();
	const [path, setPath] = useState<SearchSelectOptionProps[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const optionsPath = optionsId?.value.substr(
		optionsId?.value.lastIndexOf("/") + 1
	);

	const getEntitiesList = useCallback(async () => {
		// Gets list of entities with the field path passed
		try {
			setLoading(true);
			const res = await api.entity.getEntityProperties(
				optionsPath as string,
				isEmu
			);
			setPath(res);
		} catch (error) {
			addAlert("errorLoadingFormList", status.ERROR);
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
		setLoading(false);
	}, [isEmu, optionsPath, addAlert]);

	useEffect(() => {
		if (optionsPath !== undefined && optionsPath !== null) {
			getEntitiesList();
		} else {
			setPath([]);
			updateStore({
				elementIndex,
				property: field,
				value: null,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getEntitiesList, optionsPath]);

	const props = {
		updateStore,
		field,
		required,
		value,
		validation,
		desc,
		elementIndex,
		loading,
		options: path,
		disabled: path.length && optionsId ? false : true,
		disabledPlaceholder: t("formDesigner.placeholders.optionsIdRelation"),
		monospaceFont: !isEmu,
	};

	return <SearchSelectContainer {...props} />;
};
